import React, { useState, useEffect } from "react";
import axios from "axios";
import swal from "sweetalert";
import CompanyLogo02 from "../../../../assets/img/logos/original.png";
import CompanyLogo03 from "../../../../assets/img/logos/invalid.png";
import { useSearchParams } from "react-router-dom";
import StaffIDCard from "../inputComponents/StaffIDCard";

const VerifyStaffIDCard = (props) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  let path = window.location.origin;
  let validitys, backgroundImageurl, referenceNo;

  const [searchParams, setSearchParams] = useSearchParams();
  const [allData, setAllData] = useState([]);

  const [genaralItems, setGenaralItems] = useState({
    itemReferenceNo: null,
    value: null,
    stamp: null,
  });
  // Encrypt Decrypt Data //
  const encrypt = (encrypDycrypData, type) => {
    let result;
    if (type === "Encrypt") {
      result = window.btoa(encrypDycrypData);
    } else if (type === "Decrypt") {
      result = window.atob(encrypDycrypData);
    }
    return result;
  };

  function DiffInDays(d1, d2) {
    let days;
    days = (d2.getFullYear() - d1.getFullYear()) * 12;
    days -= d1.getMonth();
    days += d2.getMonth();
    days = days * 30;
    days -= d1.getDate();
    days += d2.getDate();
    return days <= 0 ? 0 : days;
  }

  useEffect(() => {
    if (searchParams.has("payload")) {
      const realValue = searchParams.get("payload");
      const values = encrypt(realValue, "Decrypt"); //Encrypt, Decrypt

      setGenaralItems((prev) => ({
        ...prev,
        value: values,
      }));

      (async () => await generatPrint(values))();
    } else {
    }
  }, [searchParams]);

  const generatPrint = async (filenumber) => {
    if (filenumber) {
      let datas = "?fileNumber[eq]=" + filenumber;

      await axios.get(`sanctum/csrf-cookie`).then((response) => {
        try {
          axios
            .get(`${BASE_URL}verify/staffidcardverify${datas}`)
            .then((res) => {
              if (res.data.status === 200) {
                setAllData(res.data.allData);

                res.data.allData.map((allStaffData, index) => {
                  validitys = allStaffData.validity;
                  const d2 = new Date(validitys); //
                  const d1 = new Date(); // current date

                  let totalDatss = DiffInDays(d1, d2) + 2;
                  backgroundImageurl = CompanyLogo02;

                  if ((totalDatss === 1) || (allStaffData.status !== 'Active')) {
                    swal("Oop!", "The ID Card is not valid", "warning");

                    backgroundImageurl = CompanyLogo03;
                  }
                  referenceNo =
                    path +
                    "/verifystaffidcard?payload=" +
                    encrypt(allStaffData.fileNumber, "Encrypt");

                  setGenaralItems((prev) => ({
                    ...prev,
                    itemReferenceNo: referenceNo,
                    stamp: backgroundImageurl,
                  }));

                  return <></>;
                });
              }
            });
        } catch (error) {
          swal("Oops!", "Failed", "error");
          console.log(error.response.data);
        }
      });
    }
  };

  const myStyle02 = {
    backgroundImage: `url(${genaralItems.stamp})`,
    height: "100%",
    marginLeft: "150px",
    width: "100%",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    display: "Block",
    position: "absolute",
    zIndex: "20",
  };

  return (
    <>
      <div>
        <div style={myStyle02}></div>
        <StaffIDCard
          itemValues={allData[0]}
          itemReferenceNo={genaralItems.itemReferenceNo}
        />
      </div>
    </>
  );
};
export default VerifyStaffIDCard;
